export default __webpack_public_path__ + "static/media/icon-settings.269e4d1c.svg";